import { useQuery } from '@tanstack/react-query';
import { getCommissionsAvailableActions } from 'config/requests/comissions';

export const useCommissionsAvailableActions = (id: number | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: ['commissions/available_actions', id],
    queryFn: () => getCommissionsAvailableActions(id!),
    enabled: Boolean(id),
  });

  return { data, isLoading };
};
